
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content/selling/bargain-auction",
      function () {
        return require("private-next-pages/content/selling/bargain-auction.page.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/content/selling/bargain-auction"])
      });
    }
  